/* ================================================== *\
 * Model to store SVG polygon and paths from a residence.
\* ================================================== */

import { Model } from '@vuex-orm/core';
import Residence from '@/models/Residence';

export default class Link extends Model {
  static entity = 'links';

  static fields() {
    return {
      id: this.uid(),

      label: this.attr('Meld interesse'),
      url: this.attr(null),

      // Relationship IDs
      residence_id: this.attr(null),

      // Relationships
      residence: this.belongsTo(Residence, 'residence_id'),
    };
  }
}
